import React from "react";

const NavBarFooter = () => (
  <div className='NavBarFooter'></div>
);

export default NavBarFooter;
